import { render, staticRenderFns } from "./prepare.vue?vue&type=template&id=64ee59f4&lang=pug&"
import script from "./prepare.vue?vue&type=script&lang=js&"
export * from "./prepare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports